/*
 * Desktop-only: relocate the Recommended + Recently Viewed carousels into the
 * product buy-box grid column so the sticky buy box stays pinned through them
 * and releases at the FAQ section. Mobile (<1024px) is never touched.
 */
(function () {
  var MQ = '(min-width: 1024px)';

  function relocate() {
    if (!window.matchMedia(MQ).matches) return;

    var columns = document.querySelector('.ciw-pdp__columns');
    if (!columns || columns.classList.contains('ciw-sticky-extended')) return;

    var recCarousel = document.querySelector('.ciw-pdp-product-rec__desktop');
    var recWrap = recCarousel ? (recCarousel.closest('.shopify-section') || recCarousel) : null;

    var rvSection = document.querySelector('.ciw-pdp-recently-viewed');
    var rvWrap = rvSection ? (rvSection.closest('.shopify-section') || rvSection) : null;

    var moved = false;
    if (recWrap) {
      recWrap.classList.add('ciw-relocated-rec');
      columns.appendChild(recWrap);
      moved = true;
    }
    if (rvWrap) {
      rvWrap.classList.add('ciw-relocated-rv');
      columns.appendChild(rvWrap);
      moved = true;
    }

    if (moved) columns.classList.add('ciw-sticky-extended');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocate);
  } else {
    relocate();
  }
})();
